import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import T from '../../../i18n/i18n';
import ResourceImage from '../../../ResourceImage/ResourceImage';
import { Container, EmptyItems, Item, ItemName, ItemValue, NextItems, PreviousItems, CurrentItem, ItemImage, EmptyImage } from './TurnOrderCarousel.styles';


export default () => {

    const items = useSelector(state => state.turnorderState.items);
    const characterList = useSelector(state => state.charactersState.characters);

    //let items = [];

    const avatars = useMemo(()=>{
        let mapped = [];
        if (characterList && characterList.length && items && items.length)
        items.filter(i=>i.token).forEach(i => {
            const char = characterList.find(c=>c.id===i.token)
            mapped[i.token] = char ? char.avatar : null;
        });
        return mapped;
    }, [characterList, items]);

    const prevItems = useMemo(()=> items.slice(Math.max(items.length-3, 1), items.length).reverse(), [items]);
    const nextItems = useMemo(()=>items.slice(1, 4), [items]);
    const curItem = useMemo(()=>items[0] || null, [items]);

    return <Container>
        {!items.length ? 
            <EmptyItems><T value="turnorder.emptylist" /></EmptyItems>
        :
            <>
                <PreviousItems>
                    { prevItems.map(item => <Item key={item.id}>
                        <ItemImage>
                            { item.token && avatars[item.token] ?
                                    <ResourceImage resourceId={avatars[item.token]} />
                                :
                                    <EmptyImage />
                            }
                        </ItemImage>
                        <ItemName>{item.name}</ItemName>
                        <ItemValue>{item.value}</ItemValue>
                    </Item>) }
                </PreviousItems>

                <NextItems>
                    { nextItems.map(item => <Item key={item.id}>
                        <ItemImage>
                            { item.token && avatars[item.token] ?
                                    <ResourceImage resourceId={avatars[item.token]} />
                                :
                                    <EmptyImage />
                            }
                        </ItemImage>
                        <ItemName>{item.name}</ItemName>
                        <ItemValue>{item.value}</ItemValue>
                    </Item>) }
                </NextItems>

                <CurrentItem>
                    { curItem ? <Item>
                        <ItemImage>
                            { curItem.token && avatars[curItem.token] ?
                                    <ResourceImage resourceId={avatars[curItem.token]} />
                                :
                                    <EmptyImage />
                            }
                        </ItemImage>
                        <ItemName>{curItem.name}</ItemName>
                        <ItemValue>{curItem.value}</ItemValue>
                    </Item> : null }

                </CurrentItem>
            </>
        }
    </Container>
}